import { api } from '@/services/api';
import { showAlert } from './theme';
import { POLES_SET, POLES_LOADING, POLES_LOADED } from '../actionTypes';

export const setPoles = (dataAndTotal) => ({
  type: POLES_SET,
  payload: dataAndTotal,
});

export const loadingPoles = () => ({
  type: POLES_LOADING,
});

export const loadedPoles = () => ({
  type: POLES_LOADED,
});

export const addPoleGamification = (idPolo) => {
  return (dispatch) => {
    api
      .post(`/Gamificacao/Habilitar/${idPolo}`)
      .then(() => {
        dispatch(showAlert({
          type: 'success',
          message: 'Gamificação habilitada com sucesso',
          time: 3000,
        }));
        dispatch(fetchGamificationPoles());
      })
      .catch((error) => {
        console.log('error comming', error);
      });
  };
};

export const removePoleGamification = (idPolo) => {
  return (dispatch) => {
    api
      .post(`/Gamificacao/Desabilitar/${idPolo}`)
      .then(() => {
        dispatch(showAlert({
          type: 'success',
          message: 'Gamificação desabilitada com sucesso',
          time: 3000,
        }));
        dispatch(fetchGamificationPoles());
      })
      .catch((error) => {
        console.log('error comming', error);
      });
  };
};

export const fetchGamificationPoles = (page = 1, perPage = 10, search = '') => {
  return (dispatch) => {
    dispatch(loadingPoles());

    api
      .get(`/Gamificacao/GetAllPoloByUsuarioFranqueadoraGamificacao?page=${page}&perPage=${perPage}&search=${search}`)
      .then((data) => {
        dispatch(setPoles({
          data: data.data.polosGamificacao,
          totalRows: data.data.totalRows
        }));
        dispatch(loadedPoles());
      })
      .catch((error) => {
        console.log('error comming', error);
      });
  };
};
